export default __webpack_public_path__ + "static/media/laboratory-examination.d647c6e4.jpeg";